import { makeObservable } from 'mobx';
import { Common } from 'src/domains/common/Common';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';

type PromoCodeResponseType =
    | {
          correct: true;
      }
    | {
          correct: false;
          message: string;
      };

export class PromoCodesState {
    public static get = AutoWeakMap.create((common: Common) => new PromoCodesState(common));

    private constructor(private readonly common: Common) {
        makeObservable(this);
    }

    public checkPromoCode = async (promoCodeId: string): Promise<PromoCodeResponseType> => {
        const response = await this.common.trpcClient.client.promoCodesRouter.validate.mutate({ promoCodeId });

        if (response.status !== 200) {
            return {
                correct: false,
                message: response.body.message,
            };
        }
        return {
            correct: true,
        };
    };
}
